<template>

<div class="operand" v-click-outside="onOutsideClick" v-if="optionsFinal.length">
        
    <div class="operand-text" v-on:click="onTextClick" v-tooltip="tooltip || 'Click to change'">

        <i :class="{[iconsFinal[value]]: true}" />
    
    </div>

    <core-filter-advanced-builder-dropdown align="left" :options="optionsFinal" v-on:change="onChange" v-if="expanded" />

</div>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['options', 'rule', 'tooltip', 'value', 'type'],

    data: function() {

        return {
            expanded: false,
            selected: false,
            optionIcon: {
                default: {
                    '>=': 'fa-solid fa-greater-than-equal',
                    '>': 'fa-solid fa-greater-than',
                    '<=': 'fa-solid fa-less-than-equal',
                    '<': 'fa-solid fa-less-than',
                    '=': 'fa-solid fa-equals',
                    '!=': 'fa-solid fa-not-equal'
                }
            },
            optionText: {
                default: {
                    '>=': 'Greater than or equal to',
                    '>': 'Greater than',
                    '<=': 'Less than or equal to',
                    '<': 'Less than',
                    '=': 'Equal to',
                    '!=': 'Not equal to'
                },
                numeric: {},
                category: {},
                toggle: {},
                text: {},
                text_contains: {
                    '=': 'Contains',
                    '!=': 'Does not contain'
                },
                set_match: {
                    '=': 'Is',
                    '!=': 'Is not'
                },
                set_oneof: {
                    '=': 'Is at least one of',
                    '!=': 'Is not at least one of'
                },
                set_someof: {
                    '=': 'Is exactly',
                    '!=': 'Is not exactly',
                    '>=': 'Is more than or equal to',
                    '>': 'Is more than',
                    '<=': 'Is less than or equal to',
                    '<': 'Is less than',
                },
                set_allof: {
                    '=': 'Is all of',
                    '!=': 'Is not all of'
                },
                date_day: {
                    '>=': 'On or after the day',
                    '>': 'After the day',
                    '<=': 'On or before the day',
                    '<': 'Before the day',
                    '=': 'Is in the day',
                    '!=': 'Is not in the day'
                },
                date_week: {
                    '>=': 'In or after the week',
                    '>': 'After the week',
                    '<=': 'In or before the week',
                    '<': 'Before the week',
                    '=': 'Is in the week',
                    '!=': 'Is not in the week'
                },
                date_month: {
                    '>=': 'In or after the month',
                    '>': 'After the month',
                    '<=': 'In or before the month',
                    '<': 'Before the month',
                    '=': 'Is in the month',
                    '!=': 'Is not in the month'
                },
                date_year: {
                    '>=': 'In or after the year',
                    '>': 'After the year',
                    '<=': 'In or before the year',
                    '<': 'Before the year',
                    '=': 'Is in the year',
                    '!=': 'Is not in the year'
                }
            }
        }

    },

    created: function() {

        this.selected = this.value

        if(!this.$_.contains(this.options, this.selected)) this.$emit('input', this.options[0])

    },

    watch: {

        value: function(n) {

            this.selected = n

            if(!this.$_.contains(this.options, this.selected)) this.$emit('input', this.options[0])

        }

    },

    computed: {

        iconsFinal: function() {

            var icons = this.optionIcon.default
            
            var type = this.type.type

            if(this.optionIcon[type]) icons = this.optionIcon[type]

            return icons

        },

        optionsFinal: function() {

            var options = []

            var type = this.type.type

            if (type === 'toggle') return []

            if (type === 'date') type = 'date_' + this.rule.setting.period
            if (type === 'set') type = 'set_' + this.rule.setting.logic
            if (type === 'text') type = 'text_' + this.rule.setting.logic

            this.$_.each(this.options, function(option) {

                options.push({
                    value: option,
                    text: this.optionText[type][option] || this.optionText.default[option]
                })

            }.bind(this))

            return options

        },

        optionSelected: function() {

            return this.$_.findWhere(this.options, {
                value: this.selected
            })

        }

    },

    methods: {
        
        onChange: function(value) {

            this.$emit('input', value)
            this.expanded = false

        },

        onOutsideClick: function() {

            this.expanded = false

        },

        onTextClick: function() {

            this.expanded = !this.expanded

        }

    }

}

</script>

<style scoped>

.operand {
    background-color: #22465A;
    margin-right: 4px;
    height: 40px;
}

.is-mobile .operand {
    border-radius: 4px;
}

.operand-text {
    padding: 0px 10px;
    line-height: 40px;
    width: 40px;
    text-align: center;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    font-weight: 400;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.15);
}

.is-desktop .operand-text:hover {
    background-color: rgba(255, 255, 255, 0.25);
}

.operand-icon  {
    position: absolute;
    right: 8px;
    top: 0px;
    font-size: 16px;
    width: 20px;
    text-align: center;
    line-height: 40px;
}

</style>